// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G4P3","buttons":"styles_buttons__22-Xo"};